/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import ReactHTMLParser from 'react-html-parser';
import Typography from '@material-ui/core/Typography';
import  Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import {
    object,
} from 'prop-types';
import { Link } from 'react-router-dom';
import { useUIDSeed } from 'react-uid';
import FlowerGiftsBannerImage from './FlowerGiftsBannerImage';

import Data from './ViewData';

const styles = (theme) => ({
    container: {
        [theme.breakpoints.down('sm')]: {
            maxWidth: theme.palette.tiers.container.maxWidth.downSmall,
            margin: '0 auto',
        },
        [theme.breakpoints.down('md')]: {
            maxWidth: theme.palette.tiers.container.maxWidth.downMedium,
            margin: '0 auto',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: 1440,
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: 980,
            margin: '0 auto',
        },
    },
    headerTitle: {
        textAlign: 'center',
        margin: '10px auto',
        fontWeight: 400,
        fontSize: 37,
    },
    subHeaderTitle: {
        marginBottom: 20,
        maxWidth: '19.59%',
        position: 'relative',
        width: '100%',
        padding: '10px 0',
        backgroundColor: theme.palette.cms?.primary || theme.palette.colorPrimary,
        textAlign: 'center',
        color: theme.palette.white,
        fontSize: 14,
        textDecoration: 'none',
        margin: '0 2px 0',
        display: 'inline-block',
        '&:hover': {
            backgroundColor: theme.palette.sympathyHoverColorButton,
        },
    },
    subHeaderBlock: {
        display: 'block',
        width: '100%',
        margin: '0 auto',
        textAlign: 'center',
        fontSize: 30,
    },
    product: {
        width: '100%',
        margin: '0 4px 0',
        display: 'inline-block',
        position: 'relative',
        fontSize: 14,
        maxWidth: '19%',
        marginBottom: 20,
        textDecoration: 'none',
        '& img': {
            width: '100%',
        },
    },
    productName: {
        fontSize: 11,
        color: theme.palette.colorIconHeader,
        textAlign: 'left',
        fontWeight: 700,
    },
    productPrice: {
        fontSize: 11,
        color: theme.palette.sympathyProductNameColor,
        textAlign: 'left',
    },
    imageCard: {
        width: '100%',
        marginBottom: 8,
        borderRadius: 0,
        position: ' relative',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
    },
    productImage: {
        display: 'block',
        width: 'inherit',
    },
    deliveryOption: {
        textDecoration: 'none',
        color: theme.palette.primary[900],
        fontSize: 11,
        textAlign: 'left',
        '&:hover': {
            cursor: 'pointer',
        },
    },
    sniperCorner: {
        position: 'absolute',
        bottom: 0,
        left: 0,
    },
    discountPrice: {
        color: theme.palette.sympathyDiscountColor,
        fontWeight: 'bold',
    },
    strike: {
        textDecoration: 'line-through',
    },
});

const headerSection = (classes, subHeader) => {
    const seed = useUIDSeed();
    return subHeader.map((list)  => {
        const { subHeaderLink, subHeaderTitle } = list;
        return (
            <Link key={seed(list)} className={classes.subHeaderTitle} title={subHeaderTitle} to={subHeaderLink}>{subHeaderTitle}</Link>
        );
    });
};

const productList = (classes, List) => {
    const seed = useUIDSeed();
    return List.map((product) => {
        const {
            name, productUrl, image: { imagePath, altText,  imageSnipe: { imagePath: imageSnipe, altText: altTextSnipe } },
            prices: { lowerPrice, higherPrice }, salePrices, deliveryOption,
        } = product;
        const { saleLowerPrice, saleHigherPrice } = salePrices;
        return (
            <Link
                key={seed(product)}
                to={productUrl}
                className={classes.product}
            >
                <Card className={classes.imageCard}>
                    <img
                        src={imagePath}
                        alt={altText}
                        className={classes.productImage}
                    />
                    {imageSnipe ? <img src={imageSnipe} className={classes.sniperCorner} alt={altTextSnipe} /> : null}
                </Card>
                <Grid container direction="column" className={classes.productContentWrapper}>
                    <Grid item>
                        <Typography className={classes.productName}>{name}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.productPrice}>
                            <span className={saleLowerPrice ? classes.strike : ''}> {lowerPrice ? `$${lowerPrice}` : null}{lowerPrice && higherPrice ? '-' : null}{higherPrice ? `$${higherPrice}` : null}</span>
                            {salePrices ? <span className={classes.discountPrice}> {saleLowerPrice ? ` SALE $${saleLowerPrice}` : null} {saleLowerPrice && saleHigherPrice ? '-' : null} {saleHigherPrice ? `$${saleHigherPrice}` : null} </span> : null}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.deliveryOption}>{deliveryOption}</Typography>
                    </Grid>
                </Grid>
            </Link>
        );
    });
};

const FlowerGiftsPage = ({ classes }) => {
    const {
        headerTitle, topsubHeaderTitle, subHeader, products,
    } = Data;
    return (

        <Grid container className={classes.container}>
            <h1 className={classes.headerTitle}>{ReactHTMLParser(headerTitle)}</h1>
            <FlowerGiftsBannerImage />
            <h2 className={classes.subHeaderBlock}>{ReactHTMLParser(topsubHeaderTitle)}</h2>
            <div className={classes.subHeaderBlock}>
                {headerSection(classes, subHeader)}
            </div>
            <div className={classes.subHeaderBlock}>
                {productList(classes, products)}
            </div>
        </Grid>

    );
};
FlowerGiftsPage.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(FlowerGiftsPage);
